import type { GetUserOrganizationsQueryResponse } from '~/api/gen'
import { http, HttpResponse } from 'msw'
import { organizations } from '~/msw/mocks/account'

export function getUserOrganizationsHandler() {
  return http.get<
    never,
    never,
    GetUserOrganizationsQueryResponse
  >('http://localhost:3000/api/v1/account/organizations', () => {
    return HttpResponse.json(organizations)
  })
}

// Variante « scenario » : utilisateur rattaché à aucune organisation (ex : compte
// hotline hors étude). Branchée via ?scenario=sansOffice, cf. ~/msw/scenarios.ts.
export function getUserOrganizationsSansOfficeHandler() {
  return http.get<
    never,
    never,
    GetUserOrganizationsQueryResponse
  >('http://localhost:3000/api/v1/account/organizations', () => {
    return HttpResponse.json([])
  })
}
